import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeCreateReferralMutation as useDeCreateReferralMutationType } from "@/modules/patients/detail/referral/de/services/__generated__/useDeCreateReferralMutation.graphql"

const createReferralMutation = graphql`
  mutation useDeCreateReferralMutation($input: De_createReferralLetterInput!) {
    de_createReferralLetter(input: $input) {
      de_ReferralLetter {
        id
        progressNoteId
        createdAt
        createdBy
        fileId
        patientId
        reasoning
        referralId
        signedAt
        updatedAt
        updatedBy
        medicationIds
        conditions
        allergies
        icdDiagnosis {
          id
          isAssociation
          diagnosisCode
          primaryCode
          secondaryCode
          associationType
          text
        }
        progressNote {
          pointOfCare {
            pointOfCareSpecialty {
              id
              language
              synonym
              word
            }
          }
        }
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
      }
      errors {
        ... on PatientIdIsRequired {
          message
        }
        ... on DocumentAlreadyExists {
          message
        }
      }
    }
  }
`

const useDeCreateReferralMutation = () => {
  const [commit, isFlight] = useMutation<useDeCreateReferralMutationType>(createReferralMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCreateReferralMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeCreateReferralMutation }
